<div class="stepper-tab-bar">
  <ol class="stepper-tab-bar__list">
    <ng-container
      *ngFor="let item of collection; index as itemIndex; let isLast = last"
    >
      <li
        class="stepper-tab-bar-item"
        [class.stepper-tab-bar-item--active]="itemIndex === activeIndex"
        [class.stepper-tab-bar-item--completed]="itemIndex < activeIndex"
      >
        <p class="stepper-tab-bar-item__content">{{ item.content }}</p>
      </li>

      <hr
        *ngIf="!isLast"
        class="stepper-tab-bar__divider"
        [class.stepper-tab-bar__divider--completed]="itemIndex < activeIndex"
      />
    </ng-container>
  </ol>

  <p class="stepper-tab-bar__step" [attr.aria-hidden]="true">
    {{ title }}
  </p>
</div>
